import ClassNames from '@streamloots/classnames';
import { ButtonIcon } from 'ui-library/button';
import trackEventManager from 'utils/event-manager';
import theme from './footer-button.scss';

const classNames = ClassNames(theme);

export interface FooterButtonProps {
  active: boolean;
  likeCount: number;
  commentCount: number;
  buttonId: string;
  title: string;
  label: string;
  icon: string;
  disabled?: boolean;
  contentId: string;
  location: string;
  onClick: () => void;
}

export const FooterButton = ({
  active,
  likeCount,
  buttonId,
  title,
  label,
  icon,
  disabled,
  contentId,
  commentCount,
  location,
  onClick,
}: FooterButtonProps): JSX.Element => {
  const handleClick = () => {
    trackEventManager.feedClicked({
      location,
      content_id: contentId,
      like_count: likeCount,
      comment_count: commentCount,
      button: buttonId,
    });
    onClick();
  };

  return (
    <ButtonIcon
      iconClass={classNames({
        'footer-button__icon': true,
        'footer-button__icon--no-commented': !active,
      })}
      className={classNames('footer-button')}
      icon={icon}
      label={label}
      title={title}
      ariaLabel={title}
      onClick={handleClick}
      disabled={disabled}
    />
  );
};
